<div class="p-5 d-flex flex-column justify-content-center align-items-center h-100">
  <div class="img-logo d-flex align-items-center ps-2 logo-animated mb-4">
    <img src="/assets/img/orbis/Logo_PRINCIPAL.png" height="100" alt="">
  </div>






  <div class="text-center w-100">
    <div class="text-center mt-3">
      <p style="font-size: larger;"> <strong style="font-size: larger; font-weight: bold;"> Bienvenido, </strong>
        rellena los siguientes campos para empezar el registro:</p>
    </div>

    <div class="mt-4 d-flex justify-content-center">
      <div class="input-group-custom">
        <label for="email" class="form-label mb-1 d-block text-start">{{'email' | translate}}</label>
        <input class="input_element" type="email" id="email" placeholder="{{ 'emailPlaceholder' | translate }}"
          [(ngModel)]="userInfo.email">
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <div class="input-group-custom">
        <label for="password" class="form-label mb-1 d-block text-start">{{'password' | translate}}</label>
        <input class="input_element" type="password" id="password" placeholder="{{ 'passwordPlaceholder' | translate }}"
          [(ngModel)]="userInfo.password" (blur)="validatePasswords()">
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <div class="input-group-custom">
        <label for="confirmPassword" class="form-label mb-1 d-block text-start">{{'confirmPassword' | translate}}</label>
        <input class="input_element" type="password" id="confirmPassword" placeholder="{{'confirmPasswordPlaceholder' | translate}}"
          [(ngModel)]="rePass" (blur)="validatePasswords()">
        <div *ngIf="errorPasswords" class="mt-1">
          <label class="text-small text-danger text-start d-block">{{"notSamePass" | translate}}</label>
        </div>
      </div>
    </div>
    <div class="mt-3 d-flex justify-content-center">
      <div class="button-group-custom">
        <button class="social-btn email-btn btn-primary" (click)="onSubmit()"> {{'next' | translate}}</button>
        <div class="mt-2">
          <span class="link-style" (click)="navigateToLogin()">← {{'return' | translate}}</span>
        </div>
      </div>
    </div>

  </div>
</div>
